import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { withTranslation } from "react-i18next";

import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import crossIcon from "./../../../../../assets/images/cross.svg";
import Text from "components/Text";
import styles from "./Modals.module.scss";
import { getDay } from "utils";
import moment from "moment";
import constants from "../../../../../constants";
import {
  disabledDatesForCalendar,
  everyDatesCheckExceptCustomFunction,
} from "./repeatEvent.functions";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import SchedulerCalendar from "../SchedulerCalendar";

function RepeatEventModal({
  t,
  eventDetailModal,
  seteventDetailModal,
  requestToJoin,
  selectedDate,
  selectMultipleDates,
  selectedRepeatEvent,
  setSelectedRepeatEvent,
  setselectedDate,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);
  const isMountedRef = useRef(true);

  const isSingleEvent =
    eventDetailModal?.repeatedType ===
    addEditEventsConst.repeatedOptionsValues.never;

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleRequestToJoin = useCallback(async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    try {
      await requestToJoin();
    } finally {
      isSubmittingRef.current = false;
      if (isMountedRef.current) {
        setIsSubmitting(false);
      }
    }
  }, [requestToJoin]);

  const startDay = useMemo(
    () => getDay(new Date(eventDetailModal.date)),
    [eventDetailModal.date],
  );
  const everyDatesCheckExceptCustom = useMemo(() => {
    return everyDatesCheckExceptCustomFunction(eventDetailModal);
  }, [eventDetailModal]);

  const disabledDates = ({ date }) => {
    return disabledDatesForCalendar(
      eventDetailModal,
      date,
      startDay,
      everyDatesCheckExceptCustom.get(moment(date).format("YYYY-MM")) ?? [],
    );
  };

  const addClassDate = ({ date }) => {
    return selectedDate?.includes(moment(date).format("YYYY-MM-DD"))
      ? "cus_class"
      : "cus_class_remove";
  };

  const handleSelectRepeatChange = (e) => {
    setSelectedRepeatEvent(e.target.value);
  };
  const handleClose = () => {
    seteventDetailModal({});
    setselectedDate([]);
  };

  const getMinDate = useMemo(() => {
    if (moment(eventDetailModal.date).isAfter(moment())) {
      return moment(eventDetailModal.date).toDate();
    }
    return moment().toDate();
  }, [eventDetailModal.date]);
  const eventOrShift = {
    eventOrShift: t(
      `accountOwner.${eventDetailModal?.isShift ? "shift" : "event"}Tab`,
    )?.toLowerCase(),
  };

  return (
    <Modal
      isOpen={true}
      toggle={() => handleClose()}
      className={
        "modal-dialog-centered modal-width-660 " +
        styles["repeat-event-modal-dialog"] +
        " " +
        styles["confirem-accept-modal-dialog"]
      }
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => handleClose()}>
        <img src={crossIcon} alt="close" />
      </span>

      <ModalBody className={isSingleEvent ? "text-center" : ""}>
        {isSingleEvent ? (
          <>
            <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
              <span className="modal-title-25">
                {t("scheduler.joinEvent", eventOrShift)}
              </span>
            </Text>
            <Text
              size="16px"
              className={styles["desc-text"]}
              weight="300"
              color="#535b5f"
            >
              {t("scheduler.joinSingleEventDesc", eventOrShift)}
              <br />
              {t("scheduler.joinSingleEventConfirm", eventOrShift)}
            </Text>
          </>
        ) : (
          <>
            <Text size="25px" marginBottom="20px" weight="500" color="#111b45">
              <span className="modal-title-25">
                {t(`scheduler.recurringEventEvery`, eventOrShift)}
              </span>
            </Text>

            <div className={styles.repeatEventOptions}>
              <ul>
                <li>
                  <div className="ch-radio">
                    <label className="mr-5">
                      <input
                        type="radio"
                        name="eventRepeat"
                        value={constants.SCHEDULEREVENTTYPE.All}
                        checked={
                          selectedRepeatEvent ===
                          constants.SCHEDULEREVENTTYPE.All
                        }
                        onChange={handleSelectRepeatChange}
                      />
                      <span>
                        {t(
                          `scheduler.RequesttojoineventFutureDay`,
                          eventOrShift,
                        )}
                      </span>
                    </label>
                  </div>
                </li>
                <li>
                  <div className="ch-radio">
                    <label className="mr-5">
                      <input
                        type="radio"
                        name="eventRepeat"
                        value={constants.SCHEDULEREVENTTYPE.SPECFIC}
                        checked={
                          selectedRepeatEvent ===
                          constants.SCHEDULEREVENTTYPE.SPECFIC
                        }
                        onChange={handleSelectRepeatChange}
                      />
                      <span>
                        {t(`scheduler.JoinSpecificDates`, eventOrShift)}
                      </span>
                    </label>
                  </div>
                </li>
              </ul>

              {selectedRepeatEvent === constants.SCHEDULEREVENTTYPE.SPECFIC && (
                <div className={styles.repeatEventCalendar}>
                  <SchedulerCalendar
                    minDate={getMinDate}
                    className="scheduler-calendar"
                    tileClassName={addClassDate}
                    tileDisabled={disabledDates}
                    maxDate={
                      new Date(
                        moment(
                          eventDetailModal?.repeatedEndDate,
                          "YYYY-MM-DDTHH:mm:ss",
                        ),
                      )
                    }
                    onClickDay={selectMultipleDates}
                  />
                </div>
              )}
            </div>
          </>
        )}

        <div
          className={
            styles.modalActions +
            (isSingleEvent ? ` ${styles.modalActionsCentered}` : "")
          }
        >
          <button
            className={
              "button button-round button-shadow mr-md-4 mb-3 w-sm-100 " +
              styles.requestJoinButton +
              (isSubmitting ? ` ${styles.requestJoinButtonLoading}` : "")
            }
            title={t("accountOwner.requestToJoin")}
            disabled={isSubmitting}
            onClick={handleRequestToJoin}
          >
            <span className={styles.requestJoinButtonLabel}>
              {t("accountOwner.requestToJoin")}
            </span>
            {isSubmitting && (
              <span
                className={styles.requestJoinButtonSpinner}
                aria-hidden="true"
              />
            )}
          </button>
          <button
            className="button button-round button-border button-dark btn-mobile-link mb-3"
            onClick={() => handleClose()}
            title={t("accountOwner.goBack")}
            disabled={isSubmitting}
          >
            {t("accountOwner.goBack")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(RepeatEventModal);
